import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import React, { useState } from "react";
import CustomModal from "../../../shared/CustomModal";

const PageValue = ({ page_format }) => {
    const [open, setOpen] = useState(false);




    return (
        <>
            <Button variant="outlined" size="small" onClick={() => setOpen(true)}>
                View Value
            </Button>

            <CustomModal title="Page Value" open={open} setOpen={setOpen}>
                <TableContainer component={Paper} sx={{ mt: 1 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>Key</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Value</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {page_format.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.key}</TableCell>
                                    <TableCell>{item.value}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CustomModal>
        </>
    );
};

export default PageValue;
